import { useEffect, useState } from 'react';

import { useForm } from '../hooks';

const ATALHO_AVANCAR = 'F8';
const ATALHO_VOLTAR = 'F4';

function ControllerInput({
  name,
  render,
  adapterValueOnChange = (e) => e.target.value,
  disabled = false,
  group = 'default',
  priority = 1,
  visible = true,
  deps = [],
  mask = (data) => data,
  identificador = '',
}) {
  const {
    getValue,
    setValue,
    formState,
    setFieldState,
    focusNext,
    focusNextGroup,
    register,
    handleSubmit,
    handleClose,
    subscribeField,
  } = useForm();
  const [, forceUpdate] = useState({});

  const value = getValue(name);

  useEffect(() => {
    if (!deps.length) return;

    const unsubs = deps.map((field) =>
      subscribeField(field, () => {
        forceUpdate({});
      }),
    );

    return () => {
      unsubs.forEach((unsub) => unsub());
    };
  }, [deps.join(',')]);

  useEffect(() => {
    const unsub = subscribeField(name, () => {
      forceUpdate({});
    });

    return unsub;
  }, [name]);

  function onKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      focusNext(e.target.name);
    }

    if (e.key === 'Tab') {
      e.preventDefault();
      focusNextGroup(e.target.name);
    }

    if (e.key === ATALHO_AVANCAR) {
      e.preventDefault();
      handleSubmit();
    }

    if (e.key === ATALHO_VOLTAR) {
      e.preventDefault();
      handleClose();
    }
  }

  const onChange = (e) => {
    setValue(name, mask(adapterValueOnChange(e)));
  };

  const errorLocal = formState.errors[name];

  const error = errorLocal !== '';
  const helperText = errorLocal;

  const field = {
    ...register(name, identificador),
    value,
    onChange,
    onKeyDown,
    error,
    helperText,
  };

  const disabledValue =
    typeof disabled === 'function'
      ? disabled(formState.values)
      : disabled
      ? true
      : false;

  const visibleValue =
    typeof visible === 'function'
      ? visible(formState.values)
      : visible
      ? true
      : false;

  useEffect(() => {
    setFieldState(name, {
      disabled: disabledValue,
      group,
      priority,
      identificador,
    });
  }, [disabledValue, group, priority, identificador]);

  return visibleValue
    ? render({ field: { ...field, disabled: disabledValue } })
    : null;
}

export default ControllerInput;
